import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_API_URL}/api/`,
  withCredentials: true, // important to send cookies (access & refresh tokens)
});

export const setupInterceptors = (store) => {
  // Add Fun Mode header to requests
  api.interceptors.request.use((config) => {
    const state = store.getState();
    const isFunMode = state.funMode?.isFunMode;
    config.headers["X-Fun-Mode"] = isFunMode ? "true" : "false";
    return config;
  });

  // Token refresh logic
  let isRefreshing = false;
  let failedQueue = [];

  const processQueue = (error, token = null) => {
    failedQueue.forEach((prom) => {
      if (error) {
        prom.reject(error);
      } else {
        prom.resolve(token);
      }
    });
    failedQueue = [];
  };

  api.interceptors.response.use(
    (response) => response, // direct success responses
    async (error) => {
      const originalRequest = error.config;

      // If refresh-token itself fails, redirect immediately
      if (
        error.response?.status === 401 &&
        originalRequest.url.includes("refresh-token")
      ) {
        window.location.href = "/fmr/sign-in";
        return Promise.reject(error);
      }

      // Handle 401 errors for other requests
      if (
        error.response?.status === 401 &&
        !originalRequest._retry
      ) {
        originalRequest._retry = true;

        if (isRefreshing) {
          // Queue up requests while token is refreshing
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
          })
            .then(() => api(originalRequest))
            .catch((err) => {
              window.location.href = "/fmr/sign-in";
              return Promise.reject(err);
            });
        }

        isRefreshing = true;

        try {
          await api.post("auth/refresh-token");
          processQueue(null);
          return api(originalRequest);
        } catch (refreshError) {
          processQueue(refreshError, null);
          window.location.href = "/fmr/sign-in";
          return Promise.reject(refreshError);
        } finally {
          isRefreshing = false;
        }
      }

      // If not 401 or retry already attempted
      return Promise.reject(error);
    }
  );
};

export default api;
